import { classNames, TranslatedString } from "@ct-react/core";
import { Image } from "@shared/graphql";
import { DataProps } from "../tools/components";
import RatioImage from "./medias/ratio-image";
import "./article-resume.scss";

export type ArticleResumeProps = {
  title: TranslatedString;
  address: string;
  image?: Image
}

const ArticleResume = ({ className, data }: DataProps<ArticleResumeProps>) => {

  const wrapperClasses = classNames("article-resume", className);

  return (
    <div className={wrapperClasses}>
      <div className="picture">
        {!!data!.image && <RatioImage source={data!.image.assets} ratio="1/1" />}
      </div>
      <span className="title ellipsed">{data!.title.value}</span>
      <span className="address ellipsed">{data!.address}</span>
    </div>);

}

export default ArticleResume;
